import { render, staticRenderFns } from "./ControleInterno.vue?vue&type=template&id=3d3bc995&"
import script from "./ControleInterno.vue?vue&type=script&lang=js&"
export * from "./ControleInterno.vue?vue&type=script&lang=js&"
import style0 from "./ControleInterno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports